import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Icon, Loader ,Input} from 'semantic-ui-react';
import GConf from '../../AssetsM/generalConf';
import FrameForPrint from '../../Dashboard/Assets/frameForPrint';
import usePrintFunction from '../../Dashboard/Assets/Hooks/printFunction';
import BackCard from '../Assets/backCard';
import InputLinks from '../Assets/linksData';
import { NavLink } from "react-router-dom";
import CountUp from 'react-countup';
import { toast } from 'react-toastify';
import SKLT from '../../AssetsM/usedSlk';

function ImprimerRecette() {
    //IMPRIMER / if stock NON regler non

    /*#########################[Const]##################################*/
    const Today = new Date().toISOString().split('T')[0]
    let caisseData = JSON.parse(localStorage.getItem(`Magazin_Caisse_LocalD`));
    const CaisseID = caisseData.C_ID; 
    let [totale, setTotale] = useState(0)
    let [venteRecupListe, setVenteListe] = useState([])
    let [bonsList, setBons] = useState([])


    let [totaleDep, setTotaleDep] = useState('0,000')
    let [totaleRev, setTotalRev] = useState('0,000')
    
    let [depensesListe, setDepenses] = useState([])
    let [printBtnState, setPrintBtnState] = useState(false)
    let [loaderState, setLS] = useState(true)
    let [waitingTicket, setWaitingTickets] = useState(false)
    const [loading , setLoading] = useState(false)
    let [selectedDate, setSelectedDate] = useState(Today)

    /*#########################[UseEffect]##################################*/
    useEffect(() => {
        console.log(selectedDate)
        axios.post(`${GConf.ApiCaisseLink}/recette`, {
          forPID : caisseData.PID,
          camId : CaisseID,
          toDay : selectedDate,
        })
        .then(function (response) {
            CalculateTotaveVente(response.data)
            ResumerVente(response.data)
            setLS(false)
            setLoading(true)
        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible d'afficher les resultat correct </div></>, GConf.TostInternetGonf) 
              setLoading(true)
            }
        });
      }, [])

    /*#########################[Function]##################################*/
    const PrintFunction = (frameId) =>{ usePrintFunction(frameId)}
    const MakeBonsSomme = () =>{
        let tot = 0
        bonsList.map((data) =>{
            tot = tot + (data.qte * data.valeur)
        })
        return tot 
     }
    const ResumerVente = (data) => {
         const articleMap = {};

        data.forEach(transaction => {
                let articles = [];

                try {
                    articles = JSON.parse(transaction.Articles);
                } catch (e) {
                    return; // skip malformed JSON
                }

                articles.forEach(article => {
                    const { A_Code, Name, Qte } = article;

                    if (!articleMap[A_Code]) {
                        articleMap[A_Code] = { Name, totalVente: 0 };
                    }

                    articleMap[A_Code].totalVente += Qte;
                });
            });

            setVenteListe (Object.values(articleMap).map(({ Name, totalVente }) => ({
                Name,
                totalVente
            })))
    };

     const CalculateTotaveVente = (data) => {
        let tot = 0;
        data.map((d) => {
            tot += d.Final_Value ;
            
        })
        setTotale(tot.toFixed(3))
        console.log(tot.toFixed(3))
     }
    /*#########################[Card]##################################*/
    const TotaleVente = () =>{
        return(<>
                <div className={`card card-body shadow-sm mb-2 text-center   ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-4 text-white' : '' }`}>
                    <h5 className='text-start mb-0'>Totale Ventes [X]</h5>
                    <h1 className='mt-0 display-3'><CountUp end={totale} decimals={3} decimal="," duration={1} /> </h1>
                </div>
            </>)
    }

    const GetOldRecette = (targetDay) => {
        setLoading(false)
        console.log(targetDay)
        setSelectedDate(targetDay)
        axios.post(`${GConf.ApiCaisseLink}/recette`, {
          forPID : caisseData.PID,
          camId : CaisseID,
          toDay : targetDay,
        })
        .then(function (response) {
            CalculateTotaveVente(response.data)
            ResumerVente(response.data)
            setLS(false)
            setLoading(true)
        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible d'afficher les resultat correct </div></>, GConf.TostInternetGonf) 
              setLoading(true)
            }
        });
     }
 
    const VenteListe = () =>{
        return(<>
                <div className={`card card-body shadow-sm mb-2 text-center   ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-4 text-white' : '' }`}>
                    <h5 className='text-start mb-2'>Liste des vente : </h5>
                    {loading ?  
                            <>
                                {venteRecupListe.map((data, index) => <div className='card p-2 mb-2 border-div text-start' key={index}> <b>  {data.totalVente} * {data.Name}  </b>  </div>)}
                            </>
                    : SKLT.CardList }
                      
                </div>
            </>)
    }
   
    const NetteCard = () =>{
        return(<>
                <div className={`card card-body shadow-sm mb-2 text-center   ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-4 text-white' : '' }`}>
                    <h5 className='text-start mb-1'>Imprimer </h5>

                    {
                        waitingTicket ? <> Vous avez des ticket non terminr </> 
                        :
                        <>
                        <Button className='bg-danger text-white mb-3' disabled={printBtnState} fluid onClick={(e) => PrintFunction('printRecette')}>
                            <Icon name='print' /> Imprimer Recette <Loader inverted active={loaderState} inline size='tiny' className='ms-2'/>
                        </Button>
                        <Button className='bg-info text-white' disabled={printBtnState} fluid onClick={(e) => PrintFunction('printRecette')}>
                            <Icon name='print' /> Imprimer Liste des ventes <Loader inverted active={loaderState} inline size='tiny' className='ms-2'/>
                        </Button>
                        </>
                        
                    }
                    
                </div>
            </>)
    }

    return ( <>
    <div className={`spesific-commp ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-2' : '' }`} style={{height: '100vh', overflow: 'scroll'}}>
        <BackCard data={InputLinks.backCard.rt}/>
        <br />
        <div className='container'>
            <div className='row'>
                <div className='col-12 col-lg-5 mb-3'>
                    <div className='card card-body border-div shaow-sm mb-3'>
                        <h5 className='mb-1'>Changer la date </h5>
                        <Input icon='calendar alternate' type='date' size="huge" iconPosition='left'   fluid className='mb-1' value={selectedDate}  onChange={(e) => GetOldRecette(e.target.value)}/>
                    </div>
                    <TotaleVente />
                    <NetteCard />
                </div>
                <div className='col-12 col-lg-7 mb-3'>
                    <VenteListe />
                </div>
            </div> 
        </div>
    </div>
    <FrameForPrint frameId='printRecette' src={`/Pr/caisse/recette/${selectedDate}`} />
    </> );
}

export default ImprimerRecette;